import { useContext } from 'react'
import { AuthContext } from '@/contexts/AuthContext'
import { FLAGS } from '@/lib/featureflags'

/**
 * Reports whether a feature flag is enabled for the current user's organization.
 *
 * Resolution order:
 *   1. Explicit override on org.featureFlags[key]
 *   2. Registry default from FLAGS[key].default
 *   3. false, if the key is not in the registry
 */
export function useFeatureFlag(key) {
  const ctx = useContext(AuthContext)
  return flagEnabled(ctx?.user?.organization, key)
}

/**
 * Pure helper for non-component callers (e.g. sidebar filter callbacks).
 * Same resolution rules as useFeatureFlag.
 */
export function flagEnabled(organization, key) {
  const override = organization?.featureFlags?.[key]
  if (typeof override === 'boolean') return override
  return FLAGS[key]?.default ?? false
}
